export const ENABLE_GENDER_AND_IDENTITY_FIELDS = "ENABLE_GENDER_AND_IDENTITY_FIELDS";
export const ENABLE_RELATIONSHIP_TO_ENROLLEE_FIELDS = "ENABLE_RELATIONSHIP_TO_ENROLLEE_FIELDS";
export const ENABLE_MULTIPLE_AOE_SELECTION = "ENABLE_MULTIPLE_AOE_SELECTION";
export const ENABLE_RACE_AND_ETHNICITY_FIELDS = "ENABLE_RACE_AND_ETHNICITY_FIELDS";
export const ENABLE_BLUE_BUTTON = "ENABLE_BLUE_BUTTON";
export const ENABLE_MEMBER_DASHBOARD = "ENABLE_MEMBER_DASHBOARD";
export const ENABLE_CIN_NUMBER = "ENABLE_CIN_NUMBER";
export const ENABLE_AOE_MAPPING_TO_ELECTION_PERIOD = "ENABLE_AOE_MAPPING_TO_ELECTION_PERIOD";
export const ENABLE_PLAN_DISCLAIMERS = "ENABLE_PLAN_DISCLAIMERS";
export const ENABLE_MEDICARE_SAVINGS_PROGRAM = "ENABLE_MEDICARE_SAVINGS_PROGRAM";
export const ENABLE_ENROLLMENT_BANNER = "ENABLE_ENROLLMENT_BANNER";
export const DISABLE_PCP_WIDGET_V3 = "DISABLE_PCP_WIDGET_V3";
export const ENABLE_HRA_LINK = "ENABLE_HRA_LINK";
